export const template = {
  pageTitle: "Our Story",
  contents: {
    dynamicContents: [
      {
        id: 1,
        title: "OUR CUSTOMERS ARE OUR STORY",
        subContents:
          "<strong>You, our valued customer, are our story, our highest priority, and our greatest asset!</strong>",
      },
      {
        id: 2,
        title: "",
        subContents:
          "Referrals from our customers and repeat business account for the majority of the work we do at Classy Closets. We continually strive to provide you with unparalleled service. Our designers are obsessed with finding beautiful solutions-for you, whether that be a kitchen pantry, mudroom, laundry room, cabinets or more. They are part interior designer, part mind- reader, part engineer, and part organization expert. The most important thing to them is to create a solution that thrills you and supports you. You will find an expansive selection of products offered by our designers. We differentiate our custom solutions by price point, design features, and production time, making it easy for you to choose what suits your lifestyle. All three provide more space and storage in every room of your home, which ultimately leads to more freedom, more time, and more good times.",
      },
      // {
      //   id: 3,
      //   title: "",
      //   subContents:
      //     "<span class='highlight'>Classy Closets has been improving the lives of families and businesses through well-organized closet storage solutions designed for optimal living. More than $300 million of our solutions have been sold and installed throughout the United States. Our closet storage solutions are truly customized, delivering a level of quality and value unmatched by any company in the industry. Every one of our closet storage solutions is guaranteed for life.</span>",
      // },
      {
        id: 4,
        title: "",
        subContents:
          "Classy Closets has trained closet storage professionals and closet designers who will work with you to design new custom closets and organization solutions that will maximize your space and match your individual style.",
      },
      {
        id: 5,
        title: "",
        subContents:
          "We also work with custom home builders, remodelers and production home builders.",
      },
      {
        id: 6,
        title: "",
        subContents:
          "Whether you just need a bid on a job, or for us to take care of your VIP customer, we are here to make your job easier. When you refer your customers to our closet design company, you can rest assured that we will give them unparalleled service, uncompromising quality, and an expansive selection of products for any room in the home.",
      },
      {
        id: 7,
        title: "",
        subContents:
          "When you consider Classy Closets to do the bid for your neighborhood, you can rest assured you will receive unparalleled service, uncompromising quality, and an expansive selection of products for any room in the home. We can provide a variety of options for your homes, ranging from basic standard designs for every home to large custom upgrades for the most particular customer. Our goal is to make life easier for the office personnel, the sales department, and the superintendents in the field. With many crews working all over the southwest daily, we have the connections and resources to handle almost any home building schedule.",
      },
      {
        id: 8,
        title: "",
        subContents:
          "<strong>Classy Commercial Cabinetry is a division of Classy Closets that provides custom cabinetry, millwork, and casework to General Contractors and owners of commercial projects.</strong>  Our jobs range from the small TI installation to the million-dollar high rise project. We have the manpower and experience to meet project deadlines and complete our projects on time and at the highest quality. Classy Closets Commercial Division is committed to being a leader in design innovation, state-of-the-art manufacturing techniques, and quality installations.",
      },
      {
        id: 9,
        title: "",
        subContents:
          "<strong>Interior designers bring your clients to our showroom and show them the exciting options they have for their home!</strong>  Use our conference room to meet with your clients, you are welcome any time. We value the relationship we have with Interior Designers and your clients. Your clients will receive the best service and attention you can imagine, along with the most competitive prices. We will always be happy to also work directly with the client or with you.",
      },
    ],
  },
};
